<template>
  <main>
    <div class="container-fluid">
      <div class="page-header min-height-100">
        <span class="mask bg-gradient-success opacity-6"></span>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0" v-text="Registro"></p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Informacion de Usuario</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Usuario</label
                  >
                  <argon-input type="text" v-model="model.usuario" />
                </div>
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Password</label
                  >
                  <argon-input type="password" v-model="model.password" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Confirmar Password</label
                  >
                  <argon-input
                    type="password"
                    v-model="model.confirmPassword"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="model.nombre"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Apellido Paterno</label
                  >
                  <argon-input type="text" v-model="model.paterno" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Information de Contacto</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Telefono</label
                  >
                  <argon-input type="number" v-model="model.telefono" />
                </div>
                <p v-if="model.errorMessage" style="color: red">
                  {{ model.errorMessage }}
                </p>

                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="saveData"
                  >Guardar</argon-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import usuario from "../api/usuario";
import Swal from "sweetalert2";
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ArgonInput from "@/components/ArgonInput.vue";
 import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showSidenav = false;
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
  if (localStorage.getItem("token")) {
    store.state.showSidenav = true;
  }
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
export default {
  components: {
    ArgonInput,
    ArgonButton
  },
  data() {
    return {
      status: null,
      model: {
        id: "",
        type: "registro",
        usuario: "",
        password: "",
        confirmPassword: "",
        nombre: "",
        paterno: "",
        telefono: "",
        errorMessage: "",
        status: false,
        token: "",
      },
    };
  },
  created() {
    if (localStorage.getItem("token")) {
      this.status = true;
      var token = {
        token: localStorage.getItem("token"),
      };
      usuario
        .getUsuario(token)
        .then((result) => {
          if (result.data.user[0].id) {
            this.model.type = "Update";
            this.model.id = result.data.user[0].id;
            this.model.usuario = result.data.user[0].usuario;
            this.model.password = result.data.user[0].password;
            this.model.confirmPassword = result.data.user[0].password;
            this.model.nombre = result.data.user[0].nombre;
            this.model.paterno = result.data.user[0].paterno;
            this.model.telefono = result.data.user[0].telefono;
          } else {
            alert(result.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  methods: {
    validatePassword() {
      if (this.model.password.length > 0) {
        if (this.model.password !== this.model.confirmPassword) {
          this.model.errorMessage = "La contraseña no coincide";
          this.model.status = false;
        } else {
          this.model.status = true;
        }
      } else {
        this.model.errorMessage =
          "La contraseña debe de tener un tamaño mayor a 0";
        this.model.status = false;
      }
    },
    async saveData() {
      this.model.errorMessage = null;
      this.validatePassword();
      if (
        this.model.status &&
        this.model.nombre.length > 0 &&
        this.model.paterno.length > 0 &&
        this.model.telefono.length > 0
      ) {
        usuario
          .registro(this.model)
          .then((result) => {
            if (result.data.message != null) {
              Swal.fire({
                title: "Registro Correcto",
                text: result.data.message,
                icon: "success",
                confirmButtonColor: "success",
                confirmButtonText: "Continuar",
              });
              this.$router.push({ path: "/" });
            } else {
              Swal.fire({
                title: "Error de Registro",
                text: result.data.error,
                icon: "error",
                confirmButtonColor: "error",
                confirmButtonText: "Continuar",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        return;
      }
    },
  },
};
</script>
